module.exports = __webpack_public_path__ + "img/cx.b4fc638d.jpg";